<div class="signup-tap">
  <app-text class="desktop-view" [class]="'signup-text'" (textClick)="showLogin($event)">
    Log in
  </app-text>
</div>
